import { sylvanus } from '~/services/serviceInstances';

type DeleteDdeTableRequest = {
  tableId: string;
};

export const deleteDdeTable = async ({
  tableId,
}: DeleteDdeTableRequest): Promise<void> => {
  await sylvanus.remove(`/dde/table/${tableId}`);
};
